"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GQLClient = exports.SubscriptionState = void 0;
const cache_1 = require("@apollo/client/cache");
const core_1 = require("@apollo/client/core");
const retry_1 = require("@apollo/client/link/retry");
const utilities_1 = require("@apollo/client/utilities");
require("cross-fetch/polyfill");
require("websocket-polyfill");
const defaultConfig = __importStar(require("./defaultOptions.json"));
const loggerLink_1 = require("./middlewares/loggerLink");
const WebSocketLink_1 = __importDefault(require("./WebSocketLink"));
const WEBSOCKET_URI = process.env['REACT_APP_SUBSCRIPTION_URI'] || 'ws://localhost:5000';
const ping = 'ping';
const pong = 'pong';
const closed = 'closed';
const connected = 'connected';
var SubscriptionState;
(function (SubscriptionState) {
    SubscriptionState[SubscriptionState["CONNECTING"] = WebSocket.CONNECTING] = "CONNECTING";
    SubscriptionState[SubscriptionState["CLOSED"] = WebSocket.CLOSED] = "CLOSED";
})(SubscriptionState = exports.SubscriptionState || (exports.SubscriptionState = {}));
const defaultMetrics = () => {
    const metricData = {
        duration: 0,
        httpMethod: 'GET',
        statusCode: 200,
        source: 'GRAPH',
    };
    return metricData;
};
class GQLClient {
    constructor(options, includeSubscriptions, subscriptionOptions) {
        this.config = {
            ...defaultConfig,
            ...(options || {}),
        };
        // const timeout = new ApolloLinkTimeout(defaultConfig.timeout);
        // Apollo Links configuration
        const URL = this.config.service;
        const defaultLinks = [
            loggerLink_1.loggerLink,
            // timeout,
            ...this.config.middlewares,
            new core_1.HttpLink({ uri: URL }),
        ];
        if (this.config.retry) {
            const retryOption = {
                delay: { ...this.config.retry.delay, max: Infinity },
                attempts: {
                    max: this.config.retry.maxRetries,
                    retryIf: (error, _operation) => !!error && _operation.operationName,
                },
            };
            defaultLinks.unshift(new retry_1.RetryLink(retryOption));
        }
        let link = core_1.ApolloLink.from(defaultLinks);
        if (includeSubscriptions) {
            const wsLink = new WebSocketLink_1.default({
                url: WEBSOCKET_URI,
                connectionParams: async () => {
                    var _a, _b;
                    const session = await this.config.getSession();
                    return {
                        deviceId: (_a = session === null || session === void 0 ? void 0 : session.device) === null || _a === void 0 ? void 0 : _a.id,
                        storeId: (_b = session === null || session === void 0 ? void 0 : session.currentStore) === null || _b === void 0 ? void 0 : _b.id,
                        token: session === null || session === void 0 ? void 0 : session.token,
                        app: session === null || session === void 0 ? void 0 : session.activeApp,
                    };
                },
                keepAlive: 10000,
                retryAttempts: 1e4,
                retryWait: this.config.retryWait,
                shouldRetry: () => true,
                on: {
                    [connected]: () => {
                        var _a;
                        this.subscriptionState = SubscriptionState.CONNECTING;
                        (_a = subscriptionOptions === null || subscriptionOptions === void 0 ? void 0 : subscriptionOptions.onChangeSubscriptionState) === null || _a === void 0 ? void 0 : _a.call(subscriptionOptions, this.subscriptionState);
                    },
                    [ping]: received => {
                        if (!received) {
                            clearTimeout(this.pingTimeout);
                            this.pingTimeout = setTimeout(() => {
                                var _a;
                                this.subscriptionState = SubscriptionState.CLOSED;
                                (_a = subscriptionOptions === null || subscriptionOptions === void 0 ? void 0 : subscriptionOptions.onChangeSubscriptionState) === null || _a === void 0 ? void 0 : _a.call(subscriptionOptions, this.subscriptionState);
                            }, 5000);
                        }
                    },
                    [pong]: received => {
                        var _a;
                        if (received)
                            clearTimeout(this.pingTimeout);
                        if (this.subscriptionState !== SubscriptionState.CONNECTING) {
                            this.subscriptionState = SubscriptionState.CONNECTING;
                            (_a = subscriptionOptions === null || subscriptionOptions === void 0 ? void 0 : subscriptionOptions.onChangeSubscriptionState) === null || _a === void 0 ? void 0 : _a.call(subscriptionOptions, this.subscriptionState);
                        }
                    },
                    [closed]: () => {
                        var _a;
                        if (this.pingTimeout)
                            clearTimeout(this.pingTimeout);
                        this.subscriptionState = SubscriptionState.CLOSED;
                        (_a = subscriptionOptions === null || subscriptionOptions === void 0 ? void 0 : subscriptionOptions.onChangeSubscriptionState) === null || _a === void 0 ? void 0 : _a.call(subscriptionOptions, this.subscriptionState);
                    },
                },
            });
            link = (0, core_1.split)(({ query }) => {
                const definition = (0, utilities_1.getMainDefinition)(query);
                return (definition.kind === 'OperationDefinition' &&
                    definition.operation === 'subscription');
            }, wsLink, core_1.ApolloLink.from(defaultLinks));
        }
        this.client = new core_1.ApolloClient({
            cache: this.config.cache || new cache_1.InMemoryCache(),
            link,
            name: this.config.client,
            version: this.config.version,
            resolvers: this.config.resolvers,
            typeDefs: this.config.typeDefs,
            connectToDevTools: true,
        });
    }
    getApolloClient() {
        return this.client;
    }
    getSubscriptionState() {
        return this.subscriptionState;
    }
    async query(query, variables, fetchPolicy) {
        const startTime = new Date().getTime();
        // this will be used for metric fetching time for storing at external service t later stage
        const metricData = defaultMetrics();
        metricData.httpMethod = 'POST';
        try {
            const response = await this.client.query({
                query: query.query,
                fetchPolicy,
                variables,
            });
            metricData.duration = new Date().getTime() - startTime;
            return {
                data: response.data[query.name],
                metrics: metricData,
            };
        }
        catch (error) {
            metricData.duration = new Date().getTime() - startTime;
            metricData.statusCode = error.statusCode;
            return {
                data: null,
                metrics: metricData,
                error: error['message'],
            };
        }
    }
    async mutation(mutation, variables) {
        const startTime = new Date().getTime();
        const metricData = defaultMetrics();
        try {
            const response = await this.client.mutate({
                mutation: mutation.mutate,
                variables,
            });
            metricData.duration = new Date().getTime() - startTime;
            metricData.httpMethod = 'POST';
            return {
                data: response.data[mutation.name],
                metrics: metricData,
            };
        }
        catch (error) {
            metricData.duration = new Date().getTime() - startTime;
            metricData.httpMethod = 'POST';
            return {
                data: null,
                metrics: metricData,
                error: error,
            };
        }
    }
}
exports.GQLClient = GQLClient;
//# sourceMappingURL=GQLClient.js.map